export default __webpack_public_path__ + "static/media/pupainting-small-banner.60c2ca98.jpg";